import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { PrintchallanComponent } from 'src/app/printchallan/printchallan.component';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-post-statement',
  templateUrl: './post-statement.component.html',
  styleUrls: ['./post-statement.component.scss'],
})
export class PostStatementComponent implements OnInit {
  poststatementdata;
  sub_mode;
  district;
  place;
  prati;
  publish_date;
  tempdata;
  status;
  state;
  weight_of_copy;
  // dist_id;
  total_sub_count: any;
  dist_name: any;
  today;
  prakashandate;
  vitarandate;
  Filteredpoststatementdata = [];
  data1 = [];
  disRepData = [];
  // total_s_bhet = 0;
  dispatchdate: any;
  issuedate: any;
  FilteredlabelsforDispatch: any;
  dataone: any;
  datatwo: any;
  combinedList: any;
  //district:any;
  dis_mode: any;
  dis_sub_mode: any;
  dis_date: any;
  updateStatus: any = false
  constructor(
    private dialogref: MatDialogRef<PostStatementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog,
    private service: DigisubservicesService
  ) { }
  deleveryMode: any
  taluka: any
  pincode: any
  dist_rep_name: any
  dispatchankDate: any

  ngOnInit(): void {



    this.dist_name = this.data.dist_name,
      this.dist_rep_name = this.data.dist_rep_name,
      this.district = this.data.district;
    // this.prati=this.data.prati;
    this.dis_mode = this.data.dis_mode,
      this.dis_sub_mode = this.data.dis_sub_mode,
      this.sub_mode = this.data.dis_sub_mode,
      this.issuedate = this.data.prakashandate,
      this.vitarandate = this.data.vitarandate
    this.updateStatus = this.data.updateStatus,
      this.dispatchdate = this.data.dispatchdate,
      this.dataone = this.data.data;
    this.datatwo = this.data.data1
    this.deleveryMode = this.data.deleveryMode
    this.state = this.data.state,
      this.taluka = this.data.taluka,
      this.pincode = this.data.pincode,
      console.log(this.dataone, this.datatwo, "intailze data")

    this.combinedList = this.dataone;
    console.log(this.combinedList, "Intial list")

    if (this.updateStatus) {
      // for (let j = 0; j < this.datatwo.length; j++) {
      //   let matchFound = false;

      //   for (let i = 0; i < this.combinedList.length; i++) {
      //     // Check if `dis_rep_name` matches `dsi_rep`
      //     if (this.combinedList[i].issueSellerName === this.datatwo[j].dsi_rep) {
      //       // Update the existing object
      //       this.combinedList[i].sub_count = this.datatwo[j].count;
      //       this.combinedList[i].dis_dist = this.datatwo[j].district;
      //       this.combinedList[i].dis_tal = this.datatwo[j].taluka;
      //       this.combinedList[i].dis_mode = this.datatwo[j].dis_mode;
      //       this.combinedList[i].dis_sub_mode = this.datatwo[j].dis_sub_mode;
      //       this.combinedList[i].dis_date = this.datatwo[j].dispatchdate;
      //       this.combinedList[i].prati = parseInt(this.combinedList[i].sub_count)+ parseInt(this.combinedList[i].s_bhet);


      //       matchFound = true; // Set match found flag to true
      //       break; // Exit the loop as we've found a match
      //     }
      //   }

      //   // If no match was found, add a new object to `combinedList`
      //   if (!matchFound) {
      //     const newEntry = {
      //       issueSellerName: this.datatwo[j].dsi_rep,
      //       sub_count: this.datatwo[j].count,
      //       dis_dist: this.datatwo[j].district,
      //      // dis_dist: this.datatwo[j].place,
      //       dis_date: this.datatwo[j].dispatchdate,
      //       dis_tal: this.datatwo[j].taluka,
      //       dis_mode: this.datatwo[j].dis_mode,
      //       dis_sub_mode: this.datatwo[j].dis_sub_mode,
      //       weight_of_copy:this.datatwo[j]. weight_of_copy,
      //       prati :this.datatwo[j].count,


      //     };

      //     this.combinedList.push(newEntry); 
      //     console.log( this.combinedList, "finalelist")// Add new object to `combinedList`
      //   }
      // }

      //  this.combinedList = this.combinedList.filter((a) => {
      //   let dismodeCondition = true;
      //   if (this.dis_mode != '' && this.dis_mode != undefined) {
      //     // dismodeCondition = this.dis_mode.includes(a['dis_mode']);
      //     dismodeCondition = a['dis_mode'] !== "" && this.dis_mode === a['dis_mode'];

      //   }

      //   let dis_subModeCondition = true;
      //   if (this.dis_sub_mode != '' && this.dis_sub_mode != undefined) {
      //     // dis_subModeCondition = this.dis_sub_mode.includes(a['dis_sub_mode']);
      //     dis_subModeCondition = a['dis_sub_mode'] !== "" && this.dis_sub_mode === a['dis_sub_mode'];

      //   }

      //   let dist_nameCondition = true;
      //   if (this.dist_name != '' && this.dist_name != undefined) {
      //     // dist_nameCondition = this.dist_name.includes(a['issueSellerName']);
      //     dist_nameCondition = a['issueSellerName'] !== "" && this.dist_name === a['issueSellerName'];
      //   }

      //   return (
      //     dismodeCondition &&
      //     dis_subModeCondition &&
      //     dist_nameCondition 
      //     // Add more conditions here
      //   );
      // })

      // this.total_sub_count=0;
      //   this.combinedList.forEach(element => {
      //     this.total_sub_count += element.prati;

      //   });

      this.today = formatDate(new Date(), 'dd/MM/yyyy', 'en-IN', 'GMT+0530');
      this.getDistrictwiseStatementList();
    }
    else {
      this.today = formatDate(new Date(), 'dd/MM/yyyy', 'en-IN', 'GMT+0530');
      this.getDispatchStatement();



    }


  }
  sumOfTotal: any = 0
  getDistrictwiseStatementList() {
    this.combinedList = []
    this.total_sub_count=0
    const request = {
      "issue_date": this.issuedate,
      "distributionMode": this.dis_mode,
      "subDistributionMode": this.dis_sub_mode,
    }
    this.service.getAllDistributerCopiesForHandDelevery(request).subscribe((data: any) => {
             // ✅ Extract dispatchdate from API response
    this.dispatchankDate = data.dispatchdate 
                        ?? data.data?.[0]?.dispatch_date  // fallback if nested in data array
                        ?? this.dispatchankDate;          // fallback to existing value

    console.log(this.dispatchankDate, "dispatchankDate from API"); 

      this.combinedList = data.data;
      this.total_sub_count = this.combinedList.reduce((sum, item) => {
        // Convert to number in case it's a string
        // return sum + (parseFloat(item.prati) || 0);
        return sum + (parseFloat(item.total) || 0);
      }, 0);
    });
  }
  printchallan() {
    this.dialog.open(PrintchallanComponent, {
      data: {
        issuedate: this.issuedate,
        data: this.FilteredlabelsforDispatch,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }


  saveSubscriptionBarcodesDataEntry() {
    const filteredData = this.combinedList.map((item) => ({
      issue_date: this.issuedate,
      country: "भारत",
      status: "A",
      distribution_mode: this.dis_mode,
      state: item.state,
      district: item.dis_dist || this.district,
      place: item.dis_dist || this.district,
      total: this.total_sub_count,
      added_by: 1,

      prati: item.prati,
      dispatch_date: this.dispatchdate!=undefined?this.convertDateFormat(this.dispatchdate):"",
      delivery_mode: item.delivery_mode,
      publish_date: this.dispatchdate!=undefined?this.convertDateFormat(this.dispatchdate):"",
      sub_distribution_mode: this.dis_sub_mode,
      distribution_representative: item.issueSellerName,
      allDistributerId:item.id,
    }));


    console.log(filteredData);
    this.service.saveDispatchStatementDataEntry(filteredData).subscribe((data) => {
      alert('Dispatch Statement Save Successfully!');
    });
  }
  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }

  getDispatchStatement() {
    this.combinedList=[]
    const request = {
      issue_date: this.issuedate,
      country: "भारत",
    }
    this.total_sub_count = 0;
    this.service.getDispatchStatement(request).subscribe((data: any) => {
              // ✅ Extract dispatchdate from API response
    this.dispatchankDate = data.dispatchdate 
                        ?? data.data?.[0]?.dispatch_date  // fallback if nested in data array
                        ?? this.dispatchankDate;          // fallback to existing value

    console.log(this.dispatchankDate, "dispatchankDate from API"); 
      this.combinedList = data
      this.combinedList.forEach(element => {
        this.total_sub_count += parseInt(element.prati);
        element.selected = element.selected == "false" ? false : true;
      });
    });
  }
  checkAll = false;
  masterSelected: boolean = false;
  selectedIds: any = ""
  deleteDistrictwiseStatemet: any = true;
  checkUncheckAll() {
    this.selectedIds = ""
    this.checkAll = !this.checkAll;
    this.combinedList.forEach(item => item.selected = this.checkAll);

    this.combinedList.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    // alert(this.selectedIds)
    if (this.selectedIds == "") {
      this.deleteDistrictwiseStatemet = true;
    } else {
      this.deleteDistrictwiseStatemet = false;
    }
  }
  isAllSelected() {
    this.selectedIds = ""
    this.masterSelected = this.combinedList.every(item => item.selected);
    this.combinedList.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    if (this.selectedIds == "") {
      this.deleteDistrictwiseStatemet = true;
    } else {
      this.deleteDistrictwiseStatemet = false;
    }
    // alert(this.selectedIds)
  }
    deleteDispatchStatementng() {
    const request = {
      ids: this.selectedIds
    }
    this.service.deleteDispatchStatement(request).subscribe((data: any) => {
      alert("Deleted Successfully !!");
      this.getDispatchStatement();
    });
  }
}
